import { render, staticRenderFns } from "./OnChangeFormGroupSwitch.vue?vue&type=template&id=80e920b2&"
import script from "./OnChangeFormGroupSwitch.vue?vue&type=script&lang=js&"
export * from "./OnChangeFormGroupSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OnChangeFormGroupSwitch.vue?vue&type=style&index=0&id=80e920b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports